import { render, staticRenderFns } from "./DocEditorLinkModal.vue?vue&type=template&id=daae9ab4&scoped=true&"
import script from "./DocEditorLinkModal.vue?vue&type=script&lang=ts&"
export * from "./DocEditorLinkModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daae9ab4",
  null
  
)

export default component.exports